import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import WireMatchHeader from '../common/wire-match-header';
import Wire from '../common/wire';
import KeywordResultsContext from './context';
import useScrollableWires from '../common/scrollable-wires-hooks';
import Tail from '../common/wires-list-tail';
import useGetWiresMentioningKeyword from '../../../services/wires/mentioning-keyword-service';

export default function WiresMentioning({ keyword }) {
  const { dispatch } = React.useContext(KeywordResultsContext);
  const {
    loading, infiniteRef, wires, rawData, expandList, total, showExpand, hasMore,
  } = useScrollableWires({
    isScrollable: false,
    initNumber: 20,
    useGetWires: () => useGetWiresMentioningKeyword(keyword.slug),
  });

  React.useEffect(() => {
    dispatch({
      type: 'setLoadingWiresMentioning',
      // eslint-disable-next-line no-nested-ternary
      payload: !loading ? null : (wires.length ? 'more' : 'init'),
    });
  }, [loading, dispatch, wires.length]);

  React.useEffect(() => {
    if (_.get(rawData, 'wires.length')) {
      dispatch({ type: 'setWiresMentioning', payload: rawData.wires });
    }
  }, [rawData, dispatch]);

  return (
    <>
      {!!wires.length && (
        <article>
          <WireMatchHeader query={keyword.value} text="tagged" n={total} />
          {wires.map((wire, index) => <Wire bordered={false} key={`wires-mentioning-${wire.id}`} wire={wire} position={index + 1} />)}
          <div ref={infiniteRef} />
          {!!showExpand && (
            <Tail><button type="button" onClick={expandList}>see all results</button></Tail>
          )}
          {!hasMore && <Tail><span>You have seen all the results</span></Tail>}
        </article>
      )}
    </>
  );
}

WiresMentioning.propTypes = {
  keyword: PropTypes.shape({
    value: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
